<template>
  <div class="modal-page" @click.self="$emit('close')">
    <div class="modal-comp">
      <div class="modal-header">
        <slot name="header"></slot>
      </div>
      <div class="modal-body"><slot name="body"></slot></div>
      <slot name="footer"> </slot>
    </div>

  </div>


 
</template>

<script>
export default {
  name: 'the-Modal',
  components:{
  },
  data(){
    return {
      choosed:"VISTA"
    }

  },

  
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-page{
  display: flex;
  position:fixed;
  padding: 0 15px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0,0,0,0.3);
  justify-content: center;
  align-items: center;
}



.modal-comp{
  color: white;
  width: 100%;
  padding: 36px 28px 28px 28px;
  max-width: 468px;
  background: #0B1426;
  border-radius: 16px;

}

.modal-body > div{
  width: 100%;
}


.modal-header{
  display: flex;
  width: 100%;
  font-size: clamp(15px,1.5vw,16px);
  color: white;
  font-weight: bold;
  align-items: center;
  justify-content: center;
}



</style>